import { AsyncPipe } from '@angular/common';
import { Component, input, viewChild, output } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable, of, Subject } from 'rxjs';
import { outputFromObservable } from '@angular/core/rxjs-interop';

import { GridRowSelect, SummaryButton, SummaryItem } from '../../../models';
import { BaseInlineFormComponent } from '../../base-inline-form/base-inline-form.component';
import { GridComponent } from '../../grids/grid/grid.component';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

@Component({
  selector: 'app-grid-modal',
  templateUrl: './grid-modal.component.html',
  styleUrl: './grid-modal.component.scss',
  imports: [SummaryTopComponent, BaseInlineFormComponent, GridComponent, AsyncPipe],
})
export class GridModalComponent {
  protected save$ = new Subject<void>();

  public readonly form = viewChild(BaseInlineFormComponent);
  public readonly grid = viewChild(GridComponent);

  public readonly stateKey = input<string>();
  public readonly header = input('');
  public readonly columnDefs = input<ColDef[]>([]);
  public readonly summaryTop = input<any>();
  public readonly formModel = input<any>();
  public readonly multiSelectRows = input(true);
  readonly rowData$ = input<Observable<any[]>>(of([]));
  public readonly rowData = input<any[]>();
  public readonly summaryItems = input<(model: any) => SummaryItem[]>();
  public readonly showDelete = input(false);
  public readonly labelsVertical = input(false);
  public readonly fullWidth = input(false);
  public readonly fields = input<FormlyFieldConfig[]>();
  public readonly inlineHeader = input('');
  public readonly gridHeader = input('');
  public readonly saveButtonText = input($localize`Save`);
  public readonly submitText = input('');
  public readonly submitIcon = input('');
  public readonly gridCssClass = input('modal-grid');
  public readonly showBack = input(true);
  public readonly additionalButtons = input<SummaryButton[]>();
  public readonly alwaysShowAdditionalButtons = input(false);
  public readonly create = output<void>();
  public readonly delete = output<any>();
  public readonly edit = output<any>();
  public readonly comment = output<any>();
  public readonly rowSelected = output<GridRowSelect>();
  public readonly submitted = output<void>();
  public readonly save = outputFromObservable<void>(this.save$);

  get observableSummaryTopModel() {
    return of(this.summaryTop());
  }

  get showSave(): boolean {
    return this.save$.observed;
  }

  get gridStateKey() {
    return `Modal.${this.stateKey() ?? this.header()}`;
  }
}
